$(document).ready(function() {

	$('.bloc-entrance-figure-map').each(function(index, map) {
		var lat = $(map).attr('data-latitude');
		var lng = $(map).attr('data-longitude');
		var id = $(map).attr('id');
		if (lat && lng) {
			simpleMap(lat, lng, id);
		}
	});

	// facility location map
	if ($('#bloc-facility-map').length > 0) {
		var lat = $('#bloc-facility-map').attr('data-latitude');
		var lng = $('#bloc-facility-map').attr('data-longitude');
		if (lat && lng) {
			simpleMap(lat, lng, 'bloc-facility-map');
		}
	}

	// facility photo slider
	if ($('.facility-photo-gallery').length > 0) {
		facilityPhotos();
	}

	// open/close frequently asked questions
	$('.bloc-faq-question').on('click', function() {
		$(this).parent().toggleClass('bloc-faq-active');
	});

});
